import React, { useContext, useState } from 'react';
import moment, { Moment } from 'moment';
import 'moment/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import '../TabNotificationRow.scss';
import './TabNotificationRowExecutor.scss';
import { Button, DatePicker } from 'antd';
import { Appeal } from '../../../model/Appeal';
import AppealDescription from '../../Appeal/AppealDescription/AppealDescription';
import Constants from '../../../constants/constants';
import { ExecutorAnswer } from '../../../model/ExecutorAnswer';
import TabAppealAnswer from '../../TabAppealAnswer/TabAppealAnswer';
import AppealFiles from '../../Appeal/AppealFiles/AppealFiles';
import { useAppeal } from '../../../context/appeal/AppealContext';
import { Context } from '../../../index';

interface TabNotificationRowExecutorProps {
  appeal: Appeal;
}

const TabNotificationRowExecutor = (
  props: TabNotificationRowExecutorProps
): JSX.Element => {
  const [status, setStatus] = useState(props.appeal.status.code);
  const [comment, setComment] = useState('');
  const [holdTo, setHoldTo] = useState<string | null>(null);
  const [files, setFiles] = useState<string[]>([]);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(false);
  const { store } = useContext(Context);
  const { setupAnswers, solveHandler } = useAppeal();

  const acceptFiles = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'application/pdf',
    'application/x-pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];

  const executionStatuses = [
    Constants.statusCodeExecution,
    Constants.statusCodeDeflected,
    Constants.statusCodeHold,
  ];

  const handleExecutorAnswer = () => {
    setIsSubmitDisabled(true);
    const executorAnswer: ExecutorAnswer = {
      executorText: comment,
      appeal: props.appeal.id,
      executor: store.getUserId(),
      files: files,
      holdTo: holdTo === '' ? null : holdTo,
    };

    store.setAppealAnswer(executorAnswer).then((res) => {
      if (res) {
        setStatus(Constants.statusCodeApproval);
        solveHandler(props.appeal.id);
        setupAnswers(props.appeal.id);
      }
      setTimeout(() => {
        setIsSubmitDisabled(false);
      }, 300);
    });
  };

  const handleHoldTo = (date: Moment | null) => {
    if (date) {
      setHoldTo(date.format('YYYY-MM-DD'));
    } else {
      setHoldTo('');
    }
  };

  const disabledDate = (current: Moment) => {
    return current && current < moment().endOf('day');
  };

  const fileHandler = (iri: string) => {
    setFiles((prevState) => {
      return [...prevState, iri];
    });
  };

  const fileRemoveHandler = (iri: string) => {
    setFiles(files.filter((el) => el !== iri));
  };

  return (
    <>
      {executionStatuses.includes(status) && (
        <div className="TabNotificationRowExecutor">
          <div className="descriptionContainer">
            <AppealDescription
              data={comment}
              setDescription={setComment}
              label={'Текст ответа'}
            />
          </div>
          <div className="TabNotificationRowExecutor__dateContainer">
            <label>Дата отложенного решения:</label>
            <DatePicker
              onChange={handleHoldTo}
              locale={locale}
              disabledDate={disabledDate}
              format={Constants.dateFormat}
            />
          </div>
          <div className="problemReport__files">
            <AppealFiles
              handler={fileHandler}
              removeHandler={fileRemoveHandler}
              multiple={true}
              accepts={acceptFiles}
            />
          </div>
          <Button.Group>
            <Button
              type="primary"
              onClick={() => handleExecutorAnswer()}
              disabled={(!comment && !files.length) || isSubmitDisabled}
            >
              Отправить на согласование
            </Button>
          </Button.Group>
        </div>
      )}

      <TabAppealAnswer appealId={props.appeal.id} />
    </>
  );
};

export default TabNotificationRowExecutor;
